module.exports = require("./es-PH.d.ts");